var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, styled, Button, TextField, InputLabel, Typography, IconButton, Menu, MenuItem, } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { DropFile, Dialog, ProblemList } from "@sequentech/ui-essentials";
import { FormStyles } from "@/components/styles/FormStyles";
import React, { useEffect, useRef, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { GET_UPLOAD_URL } from "@/queries/GetUploadUrl";
import { useMutation } from "@apollo/client";
import { SimpleForm, useNotify } from "react-admin";
import { EFileIntegrityPolicy } from "@sequentech/ui-core";
import { selectImportFiles } from "@/services/ImportFileSelection";
import { ImportRequestError } from "@/services/ImportRequestError";
import { SettingsContext } from "@/providers/SettingsContextProvider";
var DOWNLOAD_URL_LIFETIME_MS = 1000;
var stageLabels = {
    "select": "Select a native file to import.",
    "local-ready": "Local validation passed. Create uploads the generated ZIP, validates it with the backend and requests creation.",
    "local": "2. Local conversion and validation. No backend request has been made for these sources.",
    "uploading": "3. Upload transport: sending the accepted native package to the backend.",
    "validating": "3. Backend dry-run validation: checkOnly. The event has not been created.",
    "ready": "3. Backend dry-run passed. Final Import/Create submits a separate creation task and can still fail.",
    "uploaded": "File upload completed. Import has not started.",
    "creating": "4. Backend creation request in progress.",
    "submitted": "4. Backend creation task submitted. Follow the import task for final success or errors.",
    "transport-error": "Upload transport failed. No backend dry-run or creation was completed. Retry the upload.",
    "validation-transport-error": "Backend dry-run request failed. Validation was not confirmed; retry the upload and check the backend connection.",
    "validation-error": "Backend dry-run validation refused this package. Review the backend diagnostics below; no event was created.",
    "creation-transport-error": "Backend creation request failed. Its outcome is unconfirmed; check the import task and event list before retrying.",
    "creation-error": "Backend creation failed after dry-run validation. Review the import task and backend diagnostics below.",
};
export var ImportStyles = {
    CancelButton: styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        margin-right: auto;\n        background-color: ", ";\n        color: ", ";\n    "], ["\n        margin-right: auto;\n        background-color: ", ";\n        color: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.palette.grey[100];
    }, function (_a) {
        var theme = _a.theme;
        return theme.palette.brandColor;
    }),
    ImportButton: styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        margin-left: auto;\n    "], ["\n        margin-left: auto;\n    "]))),
};
var PasswordInputStyle = styled(FormStyles.PasswordInput)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex: 1;\n    margin: 0;\n"], ["\n    flex: 1;\n    margin: 0;\n"])));
export var ImportScreenMemo = memo(function (props) {
    var doCancel = props.doCancel, onSourceChange = props.onSourceChange, uploadCallback = props.uploadCallback, doImport = props.doImport, disableImport = props.disableImport, refresh = props.refresh, errors = props.errors, problems = props.problems, allowHistoricalSource = props.allowHistoricalSource, formatLabel = props.formatLabel;
    var requiresSha = props.fileIntegrityPolicy === EFileIntegrityPolicy.REQUIRED_SHA256;
    var globalSettings = React.useContext(SettingsContext).globalSettings;
    var configuredUrl = globalSettings.ELECTION_EVENT_IMPORT_CONVERTER_BASE_URL;
    var converterUrl = typeof configuredUrl === "string" ? configuredUrl.trim() : undefined;
    var historicalEnabled = !!allowHistoricalSource && !!converterUrl;
    var t = useTranslation().t;
    var notify = useNotify();
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(""), shaField = _b[0], setShaField = _b[1];
    var _c = React.useState(false), showShaDialog = _c[0], setShowShaDialog = _c[1];
    var _d = React.useState(false), isUploading = _d[0], setIsUploading = _d[1];
    var _e = React.useState(null), documentId = _e[0], setDocumentId = _e[1];
    var getUploadUrl = useMutation(GET_UPLOAD_URL)[0];
    var _f = useState(false), passwordDialogOpen = _f[0], setPasswordDialogOpen = _f[1];
    var passwordInputRef = useRef(null);
    var _g = useState(""), password = _g[0], setPassword = _g[1];
    var _h = useState(), theFile = _h[0], setTheFile = _h[1];
    var _j = useState(null), generatedHash = _j[0], setGeneratedHash = _j[1];
    var _k = useState(""), selectionError = _k[0], setSelectionError = _k[1];
    var _l = useState(null), downloadAnchor = _l[0], setDownloadAnchor = _l[1];
    var _m = useState(""), downloadError = _m[0], setDownloadError = _m[1];
    var _o = useState(), HistoricalImportPlugin = _o[0], setHistoricalImportPlugin = _o[1];
    var _p = useState(""), pluginLoadError = _p[0], setPluginLoadError = _p[1];
    var _q = useState([]), historicalFiles = _q[0], setHistoricalFiles = _q[1];
    var previousConverterUrl = useRef(converterUrl);
    var _r = useState("select"), stage = _r[0], setStage = _r[1];
    useEffect(function () {
        setShaField("");
        setDocumentId(null);
    }, [refresh]);
    useEffect(function () {
        var changed = previousConverterUrl.current !== converterUrl;
        previousConverterUrl.current = converterUrl;
        if ((!changed && historicalEnabled) || (!historicalFiles.length && !generatedHash))
            return;
        setHistoricalFiles([]);
        setGeneratedHash(null);
        setTheFile(undefined);
        setShaField("");
        setDocumentId(null);
        setStage("select");
        setDownloadAnchor(null);
        setDownloadError("");
    }, [converterUrl, historicalEnabled, historicalFiles.length, generatedHash]);
    useEffect(function () {
        if (!historicalEnabled || !historicalFiles.length || HistoricalImportPlugin)
            return;
        var active = true;
        setPluginLoadError("");
        void import("./HistoricalImportPlugin").then(function (module) {
            if (active)
                setHistoricalImportPlugin(function () { return module.HistoricalImportPlugin; });
        }, function () {
            if (active)
                setPluginLoadError(String(t("electionEventScreen.import.pluginLoadError", {
                    defaultValue: "Could not load the local converter. Reload the page and try again, or use a native ZIP. No files were uploaded.",
                })));
        });
        return function () {
            active = false;
        };
    }, [historicalEnabled, historicalFiles, HistoricalImportPlugin, t]);
    // Used to autofocus the password input field in the modal dialog. Just
    // using the autofocus property in PasswordInputStyle's inputProps
    // doesn't work
    useEffect(function () {
        if (passwordDialogOpen && (passwordInputRef === null || passwordInputRef === void 0 ? void 0 : passwordInputRef.current)) {
            passwordInputRef.current.focus();
        }
    }, [passwordDialogOpen, passwordInputRef.current]);
    var uploadFile = function (url, file) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, {
                        method: "PUT",
                        headers: {
                            "Content-Type": file.type,
                        },
                        body: file,
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("File upload failed");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var uploadFileToS3 = function (theFile_1, uploadPassword_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([theFile_1, uploadPassword_1], args_1, true), void 0, function (theFile, uploadPassword, packageHash) {
            var uploadedId, data, _a, error_1;
            var _b;
            if (packageHash === void 0) { packageHash = shaField; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setIsUploading(true);
                        setStage("uploading");
                        setDocumentId(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, getUploadUrl({
                                variables: {
                                    name: theFile.name,
                                    media_type: theFile.name.endsWith(".ezip")
                                        ? "application/ezip"
                                        : theFile.type,
                                    size: theFile.size,
                                    is_public: false,
                                },
                            })];
                    case 2:
                        data = (_c.sent()).data;
                        if (!((_b = data === null || data === void 0 ? void 0 : data.get_upload_url) === null || _b === void 0 ? void 0 : _b.url))
                            throw new Error("missing upload URL");
                        return [4 /*yield*/, uploadFile(data.get_upload_url.url, theFile)];
                    case 3:
                        _c.sent();
                        uploadedId = data.get_upload_url.document_id;
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _c.sent();
                        setStage("transport-error");
                        setIsUploading(false);
                        notify(t("electionEventScreen.import.fileUploadError"), { type: "error" });
                        return [2 /*return*/];
                    case 5:
                        _c.trys.push([5, 8, 9, 10]);
                        if (!uploadCallback) return [3 /*break*/, 7];
                        setStage("validating");
                        return [4 /*yield*/, uploadCallback(uploadedId, uploadPassword, packageHash)];
                    case 6:
                        _c.sent();
                        _c.label = 7;
                    case 7:
                        setDocumentId(uploadedId);
                        setStage(allowHistoricalSource && uploadCallback ? "ready" : "uploaded");
                        notify(t("electionEventScreen.import.fileUploadSuccess"), { type: "success" });
                        return [2 /*return*/, uploadedId];
                    case 8:
                        error_1 = _c.sent();
                        setStage(error_1 instanceof ImportRequestError && error_1.stage === "transport"
                            ? "validation-transport-error"
                            : "validation-error");
                        notify(t("electionEventScreen.import.fileUploadError"), { type: "error" });
                        return [3 /*break*/, 10];
                    case 9:
                        setIsUploading(false);
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    var handleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var selected, selection, theFile, isEncrypted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loading || isUploading || passwordDialogOpen)
                        return [2 /*return*/];
                    setDocumentId(null);
                    if (generatedHash && shaField === generatedHash)
                        setShaField("");
                    setGeneratedHash(null);
                    // https://fullstackdojo.medium.com/s3-upload-with-presigned-url-react-and-nodejs-b77f348d54cc
                    setPassword("");
                    selected = Array.from(files !== null && files !== void 0 ? files : []);
                    if (!selected.length)
                        return [2 /*return*/];
                    setDownloadAnchor(null);
                    setDownloadError("");
                    onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange();
                    setSelectionError("");
                    setTheFile(undefined);
                    if (allowHistoricalSource ||
                        selected.some(function (file) { return /\.(sql|xlsx)$/i.test(file.name); })) {
                        selection = selectImportFiles(selected, historicalFiles, historicalEnabled);
                        if (selection.kind === "error") {
                            setHistoricalFiles([]);
                            setStage("select");
                            setSelectionError(selection.message);
                            return [2 /*return*/];
                        }
                        if (selection.kind === "historical") {
                            setStage("local");
                            setHistoricalFiles(selection.files);
                            return [2 /*return*/];
                        }
                    }
                    else if (selected.length !== 1) {
                        setSelectionError("Drop one native file at a time.");
                        return [2 /*return*/];
                    }
                    setHistoricalFiles([]);
                    theFile = selected[0];
                    setTheFile(theFile);
                    isEncrypted = (theFile === null || theFile === void 0 ? void 0 : theFile.name.endsWith(".ezip")) || false;
                    if (isEncrypted) {
                        setPasswordDialogOpen(true);
                        return [2 /*return*/];
                    }
                    if (!theFile) return [3 /*break*/, 2];
                    return [4 /*yield*/, uploadFileToS3(theFile, "")];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setIsUploading(false);
                    notify(t("electionEventScreen.import.fileUploadError"), { type: "error" });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handlePasswordSubmit = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPasswordDialogOpen(false);
                    if (!theFile || !value) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, uploadFileToS3(theFile, password)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var validSha = /^[a-fA-F0-9]{64}$/.test(shaField);
    var submitImport = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (id) {
            var error_2;
            if (id === void 0) { id = documentId; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id || (requiresSha && !validSha))
                            return [2 /*return*/];
                        setLoading(true);
                        setStage("creating");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, doImport(id, shaField, password)];
                    case 2:
                        _a.sent();
                        setStage("submitted");
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        setStage(error_2 instanceof ImportRequestError && error_2.stage === "transport"
                            ? "creation-transport-error"
                            : "creation-error");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var onImportButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requiresSha && !validSha)
                        return [2 /*return*/];
                    if (generatedHash && !historicalEnabled)
                        return [2 /*return*/];
                    if (!(generatedHash && theFile && !documentId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, uploadFileToS3(theFile, "", generatedHash)];
                case 1:
                    id = _a.sent();
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, submitImport(id)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
                case 4:
                    if (!shaField) {
                        setShowShaDialog(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, submitImport()];
                case 5:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isWorking = function () { return loading || isUploading; };
    var downloadConvertedZip = function () {
        setDownloadAnchor(null);
        setDownloadError("");
        if (!historicalEnabled || !generatedHash || !theFile || isWorking())
            return;
        var url;
        var link;
        try {
            // Reuse the accepted File itself: download and upload share identical bytes/name/type.
            url = URL.createObjectURL(theFile);
            link = document.createElement("a");
            link.href = url;
            link.download = theFile.name;
            document.body.appendChild(link);
            link.click();
        }
        catch (_a) {
            setDownloadError(String(t("electionEventScreen.import.downloadError", {
                defaultValue: "Could not start the ZIP download. Try Download ZIP again. This action does not upload or import the package.",
            })));
        }
        finally {
            link === null || link === void 0 ? void 0 : link.remove();
            if (url) {
                var objectUrl_1 = url;
                // Let the browser begin consuming the download before releasing its URL.
                setTimeout(function () { return URL.revokeObjectURL(objectUrl_1); }, DOWNLOAD_URL_LIFETIME_MS);
            }
        }
    };
    return (_jsxs(Box, { sx: { padding: "0" }, children: [_jsx(TextField, { disabled: isWorking() || !!generatedHash, required: requiresSha, helperText: requiresSha ? t("electionEventScreen.import.shaRequiredHelp") : undefined, error: requiresSha && shaField.length > 0 && !validSha, label: String(t("electionEventScreen.import.sha")), size: "small", value: shaField, onChange: function (e) {
                    return setShaField(e.target.value);
                } }), _jsx(Box, { component: "fieldset", disabled: isWorking(), sx: { border: 0, m: 0, p: 0 }, children: _jsx(DropFile, { multiple: historicalEnabled, formatLabel: formatLabel !== null && formatLabel !== void 0 ? formatLabel : (allowHistoricalSource ? "ZIP / JSON / EZIP" : undefined), handleFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, handleFiles(files)];
                    }); }); } }) }), selectionError && (_jsx(Typography, { role: "alert", color: "error", children: selectionError })), historicalEnabled &&
                historicalFiles.length > 0 &&
                (HistoricalImportPlugin ? (_jsx(HistoricalImportPlugin, { baseUrl: converterUrl, disabled: isWorking(), droppedFiles: historicalFiles, onPrepare: function () {
                        setDownloadAnchor(null);
                        setDownloadError("");
                        setStage("local");
                        setDocumentId(null);
                        setShaField("");
                        setGeneratedHash(null);
                        setTheFile(undefined);
                    }, onAccepted: function (file, hash) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            setPassword("");
                            setTheFile(file);
                            setShaField(hash);
                            setGeneratedHash(hash);
                            setStage("local-ready");
                            return [2 /*return*/];
                        });
                    }); } })) : (_jsx(Typography, { role: pluginLoadError ? "alert" : "status", color: pluginLoadError ? "error" : undefined, children: pluginLoadError ||
                        String(t("electionEventScreen.import.loadingConverter", {
                            defaultValue: "Loading local converter…",
                        })) }))), stage !== "select" && (_jsx(Typography, { role: "status", "data-testid": "import-stage", color: stage.endsWith("error") ? "error" : undefined, sx: { mt: 2 }, children: String(t("electionEventScreen.import.stage.".concat(stage), {
                    defaultValue: stageLabels[stage],
                })) })), downloadError && (_jsx(Typography, { role: "alert", color: "error", children: downloadError })), _jsxs(FormStyles.StatusBox, { children: [isWorking() ? _jsx(FormStyles.ShowProgress, {}) : null, problems && problems.length > 0 ? (_jsxs(Box, { sx: { width: "100%" }, "data-testid": "import-problems", children: [_jsx(Typography, { variant: "body2", children: String(t("electionEventScreen.import.backendDiagnostics", {
                                    defaultValue: "Backend diagnostics from the latest validation or creation request",
                                })) }), _jsx(ProblemList, { report: { problems: problems } })] })) : errors ? (_jsx(FormStyles.ErrorMessage, { variant: "body2", children: errors })) : null] }), _jsxs(Box, { sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "16px",
                }, children: [_jsx(ImportStyles.CancelButton, { disabled: isWorking(), onClick: function () { return doCancel(); }, children: t("electionEventScreen.import.cancel") }), historicalEnabled && generatedHash && theFile && (_jsxs(_Fragment, { children: [_jsx(IconButton, { "aria-label": String(t("electionEventScreen.import.downloadOptions", {
                                    defaultValue: "Converted ZIP options",
                                })), "aria-haspopup": "menu", "aria-expanded": !!downloadAnchor, disabled: isWorking(), onClick: function (event) { return setDownloadAnchor(event.currentTarget); }, children: _jsx(MoreHorizIcon, {}) }), _jsx(Menu, { anchorEl: downloadAnchor, open: !!downloadAnchor, onClose: function () { return setDownloadAnchor(null); }, children: _jsx(MenuItem, { onClick: downloadConvertedZip, disabled: isWorking(), children: String(t("electionEventScreen.import.downloadZip", {
                                        defaultValue: "Download ZIP",
                                    })) }) })] })), _jsx(ImportStyles.ImportButton, { sx: { marginLeft: generatedHash ? 1 : "auto" }, disabled: (!documentId && !generatedHash) ||
                            (!!generatedHash && !historicalEnabled) ||
                            isWorking() ||
                            disableImport ||
                            stage === "validation-error" ||
                            !!errors ||
                            (problems === null || problems === void 0 ? void 0 : problems.some(function (p) { return p.severity === "error"; })) ||
                            showShaDialog ||
                            (requiresSha && !validSha), onClick: onImportButtonClick, children: generatedHash
                            ? String(t("electionEventScreen.import.create", { defaultValue: "Create" }))
                            : t("electionEventScreen.import.import") })] }), _jsx(Dialog, { variant: "warning", open: !requiresSha && showShaDialog, ok: String(t("electionEventScreen.import.shaDialog.ok")), cancel: String(t("electionEventScreen.import.shaDialog.cancel")), title: String(t("electionEventScreen.import.shaDialog.title")), handleClose: function (result) {
                    if (result && !requiresSha) {
                        void submitImport();
                    }
                    setShowShaDialog(false);
                }, children: t("electionEventScreen.import.shaDialog.description") }), _jsx(Dialog, { open: passwordDialogOpen, handleClose: handlePasswordSubmit, title: String(t("electionEventScreen.import.passwordDialog.title")), ok: "Ok", variant: "info", children: _jsx(_Fragment, { children: _jsx(SimpleForm, { toolbar: false, component: Box, children: _jsxs(Box, { children: [_jsxs(InputLabel, { children: [t("electionEventScreen.import.passwordDialog.description"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "password", helperText: false, onChange: function (e) { return setPassword(e.target.value); }, inputProps: {
                                        "ref": passwordInputRef,
                                        "aria-label": t("electionEventScreen.import.passwordDialog.label"),
                                    } })] }) }) }) })] }));
});
ImportScreenMemo.displayName = "ImportScreen";
export var ImportScreen = ImportScreenMemo;
var templateObject_1, templateObject_2, templateObject_3;
